module.exports = __webpack_public_path__ + "static/media/valor1.e6f2d9a3.png";